export default __webpack_public_path__ + "static/media/Pénzügyek.63adcafb.png";